<template>
  <div>
    <v-row class="mb-4 pa-2">
      <v-col cols="12" sm="6" md="3">
        <v-skeleton-loader
          v-if="!dataLoaded"
          type="card"
          height="150"
        ></v-skeleton-loader>
        <v-card v-else-if="selectedTeam[0] === 'Un-Assigned'">
          <v-card-text>
            <div class="text-h6">{{ $t('cards.unassigned') }}</div>
            <div class="text-h4">{{ unassignedStats.percentage.toFixed(1) }}%</div>
            <v-progress-linear :model-value="unassignedStats.percentage"></v-progress-linear>
            <div class="text-body-2 mt-2">
              {{ unassignedStats.count }} / {{ unassignedStats.total }}
            </div>
          </v-card-text>
        </v-card>
        <v-card v-else>
          <v-card-text>
            <div class="text-h6">{{ $t('cards.userUnassigned') }}</div>
            <div class="text-h4">{{ userUnassignedStats.percentage.toFixed(1) }}%</div>
            <v-progress-linear :model-value="userUnassignedStats.percentage"></v-progress-linear>
            <div class="text-body-2 mt-2">
              {{ userUnassignedStats.count }} / {{ teamStats.filteredCount }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-skeleton-loader
          v-if="!dataLoaded"
          type="card"
          height="150"
        ></v-skeleton-loader>
        <v-card v-else>
          <v-card-text>
            <div class="text-h6">{{ $t('cards.draft') }}</div>
            <div class="text-h4">{{ draftStats.percentage.toFixed(1) }}%</div>
            <v-progress-linear :model-value="draftStats.percentage"></v-progress-linear>
            <div class="text-body-2 mt-2">
              {{ draftStats.count }} / {{ selectedTeam[0] === 'Un-Assigned' ? draftStats.total : teamStats.filteredCount }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-skeleton-loader
          v-if="!dataLoaded"
          type="card"
          height="150"
        ></v-skeleton-loader>
        <v-card v-else>
          <v-card-text>
            <div class="text-h6">{{ $t('cards.open') }}</div>
            <div class="text-h4">{{ openStats.percentage.toFixed(1) }}%</div>
            <v-progress-linear :model-value="openStats.percentage"></v-progress-linear>
            <div class="text-body-2 mt-2">
              {{ openStats.count }} / {{ selectedTeam[0] === 'Un-Assigned' ? openStats.total : teamStats.filteredCount }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-skeleton-loader
          v-if="!dataLoaded"
          type="card"
          height="150"
        ></v-skeleton-loader>
        <v-card v-else>
          <v-card-text>
            <div class="text-h6">{{ $t('cards.closed') }}</div>
            <div class="text-h4">{{ closedStats.percentage.toFixed(1) }}%</div>
            <v-progress-linear :model-value="closedStats.percentage"></v-progress-linear>
            <div class="text-body-2 mt-2">
              {{ closedStats.count }} / {{ selectedTeam[0] === 'Un-Assigned' ? closedStats.total : teamStats.filteredCount }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <StackedHorizontalBarChart
          :title="$t('teamAndUserBreakdown')"
          :exportFilename="$t('teamAndUserBreakdown') + '.png'"
          v-bind="teamsUsersChart"
          :filterContext="filterContext"
          :chartFontColor="chartFontColor"
          :chartCardHeight="940"
          :dataLoaded="dataLoaded"
        />
      </v-col>
      <v-col cols="12" md="6">
        <StackedHorizontalBarChart
          :title="$t('itemBreakdown')"
          :exportFilename="$t('itemBreakdown') + '.png'"
          v-bind="categoryChart"
          :filterContext="filterContext"
          :chartFontColor="chartFontColor"
          :dataLoaded="dataLoaded"
          v-model:currentLevel="categoryLevel"
        />
        <StackedHorizontalBarChart
          :title="$t('drawingBreakdown')"
          :exportFilename="$t('drawingBreakdown') + '.png'"
          v-bind="drawingChart"
          :filterContext="filterContext"
          :chartFontColor="chartFontColor"
          :dataLoaded="dataLoaded"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="12">
        <ItemsGrid v-bind="grid" />
      </v-col>
    </v-row>
  </div>
</template>

<script src="./model.js"></script>
<style src="./style.css" scoped></style>
